import SelfieRequestLinkHandlerHeadMeta from './SelfieRequestLinkHandlerMeta';

export default SelfieRequestLinkHandlerHeadMeta;
